// extracted by mini-css-extract-plugin
module.exports = {"expectations":"styles_expectations__EPzzi","card":"styles_card__ygoZv","footer":"styles_footer__Wt01N","pulse":"styles_pulse__2WStF","jump":"styles_jump__f51_e"};